import { Extension } from "@tiptap/core";
import Suggestion, { type SuggestionOptions } from "@tiptap/suggestion";

export default Extension.create({
  name: "slashCommands",

  addOptions(): { suggestion: Partial<SuggestionOptions> } {
    return {
      suggestion: {
        char: "/",
        command: ({ editor, range, props }) => {
          props.command({ editor, range });
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
        // don't show for titles
        allow: ({ editor }) => !editor.isActive("title"),
      }),
    ];
  },
});
